import {createFileRoute, redirect} from '@tanstack/react-router';

/** Legacy redirect: /profile/lists → /dashboard/lists. */
export const Route = createFileRoute('/profile/lists/')({
  beforeLoad: () => {
    throw redirect({to: '/dashboard/lists'});
  },
});
